/**
 * Video tracking constants for consistent naming and metadata across the site
 */

export const VIDEO_TITLES = {
    HERO: 'Hero Video - Math Music Video',
    SCIENCE_FUN: 'Science & Fun Explainer',
    SUCCESS_STORIES: 'Success Stories - Real Impact',
} as const;

export const VIDEO_IDS = {
    HERO: '1052420726',
    SCIENCE_FUN: '1051215207',
    SUCCESS_STORIES: '1052420897',
} as const;

export const VIDEO_SECTIONS = {
    HERO: 'hero',
    FEATURES: 'features',
    TESTIMONIALS: 'testimonials',
} as const;

export interface VideoTrackingMetadata {
    videoTitle: string;
    videoUrl: string;
    videoSection: string;
    videoPosition: number;
}

export const HOMEPAGE_VIDEOS: Record<string, VideoTrackingMetadata> = {
    hero: {
        videoTitle: VIDEO_TITLES.HERO,
        videoUrl: `https://vimeo.com/${VIDEO_IDS.HERO}`,
        videoSection: VIDEO_SECTIONS.HERO,
        videoPosition: 1,
    },
    scienceFun: {
        videoTitle: VIDEO_TITLES.SCIENCE_FUN,
        videoUrl: `https://vimeo.com/${VIDEO_IDS.SCIENCE_FUN}`,
        videoSection: VIDEO_SECTIONS.FEATURES,
        videoPosition: 2,
    },
    successStories: {
        videoTitle: VIDEO_TITLES.SUCCESS_STORIES,
        videoUrl: `https://vimeo.com/${VIDEO_IDS.SUCCESS_STORIES}`,
        videoSection: VIDEO_SECTIONS.TESTIMONIALS,
        videoPosition: 3,
    },
};
